import './Username.scss'

import { useState } from 'react'

import { GenerateUsername } from '../../../../../../../../hooks/GenerateUsername'
import LanderChat from '../../LanderChat/LanderChat'
import Button from '../../UI/Button/Button'
import Input from '../../UI/Input/Input'

export default function Username({
  setValue,
  errors,
  clearErrors,
  handleNextStep,
  landerId,
  getValues,
  options,
  watch,
}) {
  const [isElementVisible, setIsElementVisible] = useState(false)
  const [showUsernamePopup, setShowUsernamePopup] = useState(false)
  const [randomUsername, setRandomUsername] = useState(null)

  const messages = {
    '13-1': `Great!\n Now pick a Username${
      options.autogeneratePassword ? '' : ' and Password'
    }.`,
    '13-2': `Nice! You’re almost done.\n Enter your Username${
      options.autogeneratePassword ? '' : ' and Password'
    }.`,
    '13-3': `That’s great thank you.\n How about your Username${
      options.autogeneratePassword ? '' : ' and Password'
    }?`,
    '13-4': `Nice job!\n Please tell me your Username${
      options.autogeneratePassword ? '' : ' and Password and we are good to go'
    }.`,
  }

  const getMessage = () => {
    const content = messages[`${landerId}`]

    if (options.autogenerateUsername) {
      return [
        {
          content: `${content.replace(
            '\n',
            '',
          )} I made a username suggestion for you.`,
        },
      ]
    }

    return [{ content }]
  }

  const message = getMessage()

  const toggleElementVisibility = () => {
    setIsElementVisible(!isElementVisible)
  }

  const handleToggleUsernamePopup = () => {
    if (!showUsernamePopup) {
      generateUsername()
    }

    setShowUsernamePopup(!showUsernamePopup)
  }

  const generateUsername = () => {
    const email = getValues('email')
    setRandomUsername(GenerateUsername(email))
  }

  return (
    <div className="UsernameContainer">
      <LanderChat
        messages={message}
        endChatAction={toggleElementVisibility}
        landerId={landerId}
      />

      <div className={isElementVisible ? 'ToggleElement' : 'Hidden'}>
        <div className="InputsContainer13">
          <div className="UsernameFieldContainer">
            <div className="UsernameInputContainer">
              <Input
                placeholder="Username"
                name="username"
                value={getValues('username')}
                status={errors.username?.message ? 'error' : ''}
                onChange={e => {
                  setValue('username', e.target.value)
                  clearErrors('username')
                }}
                {...{
                  errors,
                  setValue,
                  clearErrors,
                }}
              />
              {options.autogenerateUsername && (
                <div
                  className="UsernameToggleIcon"
                  onClick={handleToggleUsernamePopup}
                >
                  <ToggleIcon />
                </div>
              )}
            </div>
            {showUsernamePopup && options.autogenerateUsername && (
              <div className="RandomUsernameContainer">
                <div className="RandomUsernameLabel">
                  <span>Username suggestion</span>
                  <div className="ReloadIcon" onClick={generateUsername}>
                    <ReloadIcon />
                  </div>
                </div>
                <div
                  className="RandomUsernameValue"
                  onClick={() => {
                    setValue('username', randomUsername)
                    setShowUsernamePopup(false)
                  }}
                >
                  {randomUsername}
                </div>
              </div>
            )}
          </div>
          {!options.autogeneratePassword && (
            <>
              <Input
                placeholder="Enter your password"
                name="password"
                type="password"
                {...{
                  errors,
                  setValue,
                  clearErrors,
                }}
              />
              <span className="PasswordHelpText">
                It must be at least 6 Characters
              </span>
            </>
          )}
          {options.autogeneratePassword && (
            <span className="AutogeneratePasswordMsg">
              Your password will be sent on your Welcome Email<br></br>Do not
              re-share
            </span>
          )}
        </div>
        <div className="ButtonsContianer">
          <Button
            className={`ButtonDark`}
            text="FINISH"
            handleNextStep={() => handleNextStep(['username', 'password'])}
            disabled={!watch('username') || !watch('password')}
          />
        </div>
      </div>
    </div>
  )
}

const ReloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
  >
    <path d="M22.3679 19.7269C22.5485 19.8572 22.6702 20.0536 22.7065 20.2733C22.7429 20.493 22.6909 20.7182 22.562 20.8997C16.4026 29.4553 2.75915 25.1184 2.69165 14.5716L1.8479 15.5419C1.70021 15.7108 1.49145 15.8142 1.26755 15.8292C1.04365 15.8443 0.822944 15.7697 0.653992 15.622C0.485041 15.4743 0.38168 15.2656 0.366648 15.0417C0.351616 14.8178 0.426144 14.5971 0.573836 14.4281L2.89415 11.8125C3.06234 11.6431 3.28843 11.5436 3.52696 11.5341C3.76734 11.5463 3.99514 11.6452 4.16821 11.8125L6.48852 14.4281C6.63622 14.5971 6.71074 14.8178 6.69571 15.0417C6.68068 15.2656 6.57732 15.4743 6.40837 15.622C6.23942 15.7697 6.01871 15.8443 5.79481 15.8292C5.57091 15.8142 5.36215 15.7108 5.21446 15.5419L4.37071 14.5884C4.38892 16.5448 5.0249 18.4454 6.18781 20.0188C7.35073 21.5921 8.98111 22.7578 10.8461 23.3492C12.711 23.9406 14.7152 23.9275 16.5723 23.3118C18.4293 22.6961 20.0444 21.5093 21.1866 19.9209C21.2512 19.8303 21.3331 19.7534 21.4275 19.6946C21.522 19.6358 21.6271 19.5962 21.7369 19.5782C21.8467 19.5601 21.959 19.564 22.0673 19.5895C22.1755 19.615 22.2777 19.6617 22.3679 19.7269ZM26.4854 12.7659C26.407 12.6869 26.3136 12.6241 26.2108 12.5813C26.108 12.5384 25.9977 12.5164 25.8863 12.5164C25.775 12.5164 25.6647 12.5384 25.5618 12.5813C25.459 12.6241 25.3657 12.6869 25.2873 12.7659L24.5701 13.4831C23.6757 3.375 10.5976 -0.0590582 4.74196 8.10844C4.63437 8.2901 4.5988 8.50549 4.64226 8.7121C4.68572 8.9187 4.80506 9.10151 4.97672 9.22442C5.14838 9.34734 5.35988 9.40143 5.56947 9.37603C5.77906 9.35062 5.97152 9.24756 6.10884 9.08719C11.0616 2.15157 22.3426 5.16375 22.832 13.7109L21.9376 12.4959C21.8033 12.3169 21.6034 12.1986 21.3819 12.1669C21.1604 12.1353 20.9354 12.1929 20.7563 12.3272C20.5773 12.4615 20.459 12.6613 20.4273 12.8829C20.3957 13.1044 20.4533 13.3294 20.5876 13.5084L22.5957 16.1916C22.6731 16.3308 22.7853 16.4476 22.9214 16.5304C23.0575 16.6132 23.2127 16.6593 23.372 16.6641C23.595 16.6676 23.8104 16.5827 23.971 16.4278L26.5023 13.9556C26.6572 13.7953 26.7424 13.5802 26.7392 13.3573C26.7361 13.1344 26.6448 12.9218 26.4854 12.7659Z" />
  </svg>
)

const ToggleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
  >
    <rect width="27" height="27" rx="4" />
    <circle cx="8" cy="13" r="2" fill="white" />
    <circle cx="14" cy="13" r="2" fill="white" />
    <circle cx="20" cy="13" r="2" fill="white" />
  </svg>
)
